import isEmpty from 'lodash-es/isEmpty';
import isEqual from 'lodash-es/isEqual';
import isObject from 'lodash-es/isObject';
import transform from 'lodash-es/transform';

export interface IDIfference<T> {
    from: T | undefined;
    to: T | undefined;
}

/**
 * Deep diff between two object, using lodash
 * @param  {Object} after Object compared
 * @param  {Object} before   Object to compare with
 * @return {Object}        Return a new object who represent the diff
 */
export function difference(after, before, skipEmpty = false) {
    const _isEmpty = value => {
        return typeof value === 'object' && isEmpty(value);
    };

    const missingPart = transform(before, (result, value, key) => {
        if ((skipEmpty ? !_isEmpty(value) : value !== undefined) && after[key] === undefined) {
            result[key] = undefined;
        }
    }) as any;

    return transform({ ...after, ...missingPart }, (result: any, value, key) => {
        if (!(skipEmpty && _isEmpty(value) && _isEmpty(before[key])) && !isEqual(value, before[key])) {
            if (isObject(value) && isObject(before[key])) {
                const diff = difference(value, before[key], skipEmpty);
                if (!_isEmpty(diff)) {
                    result[key] = diff;
                }
            } else {
                result[key] = { from: before[key], to: value } as IDIfference<typeof value>;
            }
        }
    });
}

export function isDifference(object: any): boolean {
    if (!object || !isObject(object)) {
        return false;
    }

    //  check if object has from and to properties

    const keys = Object.keys(object);
    return keys.length === 2 && keys.includes('from') && keys.includes('to');
}
